/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/components/shared/Display.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { HugeiconsIcon } from "@hugeicons/react";
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription } from "../ui/empty.js";
import { _jac } from "@jac/prelude";
function status_label(claim_type) {
  if ((claim_type === "MISSING")) {
    return "Missing";
  }
  if ((claim_type === "FOUND_SAFE")) {
    return "Safe";
  }
  if ((claim_type === "INJURED")) {
    return "Injured";
  }
  if ((claim_type === "DECEASED")) {
    return "Deceased";
  }
  if ((claim_type === "SEEN_AT_LOCATION")) {
    return "Seen";
  }
  return "No status yet";
}
function status_sentence(claim_type) {
  if ((claim_type === "MISSING")) {
    return "Reported missing";
  }
  if ((claim_type === "FOUND_SAFE")) {
    return "Reported safe";
  }
  if ((claim_type === "INJURED")) {
    return "Reported injured";
  }
  if ((claim_type === "DECEASED")) {
    return "Reported deceased";
  }
  if ((claim_type === "SEEN_AT_LOCATION")) {
    return "Reported seen";
  }
  return "Report";
}
function source_kind(source_type) {
  let kinds = {"POLICE": "Police", "HOSPITAL": "Hospital", "COMMUNITY": "Community member", "NGO": "Aid group", "GOVERNMENT": "Government"};
  return _jac.dict.get(kinds, source_type, "Source");
}
function status_text(claim_type) {
  if ((claim_type === "MISSING")) {
    return "text-status-missing";
  }
  if ((claim_type === "FOUND_SAFE")) {
    return "text-status-safe";
  }
  if ((claim_type === "INJURED")) {
    return "text-status-warning";
  }
  return "text-status-neutral";
}
function status_badge(claim_type) {
  if ((claim_type === "MISSING")) {
    return "bg-status-missing-soft text-status-missing border-status-missing/40";
  }
  if ((claim_type === "FOUND_SAFE")) {
    return "bg-status-safe-soft text-status-safe border-status-safe/40";
  }
  if ((claim_type === "INJURED")) {
    return "bg-status-warning-soft text-status-warning border-status-warning/40";
  }
  return "bg-status-neutral-soft text-status-neutral border-border";
}
function status_dot(claim_type) {
  if ((claim_type === "MISSING")) {
    return "bg-status-missing";
  }
  if ((claim_type === "FOUND_SAFE")) {
    return "bg-status-safe";
  }
  if ((claim_type === "INJURED")) {
    return "bg-status-warning";
  }
  return "bg-status-neutral";
}
function friendly_time(iso) {
  if (!iso) {
    return "Time unknown";
  }
  if ((iso.length < 16)) {
    return iso;
  }
  let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let hour = Math.trunc(Number(iso.slice(11, 13)));
  let suffix = ((hour < 12) ? "AM" : "PM");
  let hour12 = _jac.int.mod(hour, 12);
  if ((hour12 === 0)) {
    hour12 = 12;
  }
  let zone = ((iso.endsWith("+00:00") || iso.endsWith("Z")) ? " UTC" : "");
  return (((((((((months.at((Math.trunc(Number(iso.slice(5, 7))) - 1)) + " ") + String(Math.trunc(Number(iso.slice(8, 10))))) + ", ") + String(hour12)) + ":") + iso.slice(14, 16)) + " ") + suffix) + zone);
}
function plural(n, word) {
  return (((String(n) + " ") + word) + (((n === 1) ? "" : "s")));
}
function SectionHeading(props) {
  const {title, subtitle: subtitle = ""} = props;
  return __jacJsx("div", {"className": "flex flex-col gap-1"}, [__jacJsx("h2", {"className": "font-display text-2xl leading-tight tracking-tight"}, [title]), (subtitle && __jacJsx("p", {"className": "text-sm text-muted-foreground"}, [subtitle]))]);
}
function EmptyPanel(props) {
  const {icon, title, text} = props;
  return __jacJsx(Empty, {"className": "border border-dashed border-border pt-8 pb-8"}, [__jacJsx(EmptyHeader, {}, [__jacJsx(EmptyMedia, {"variant": "icon"}, [__jacJsx(HugeiconsIcon, {"icon": icon, "strokeWidth": 2}, [])]), __jacJsx(EmptyTitle, {}, [title]), __jacJsx(EmptyDescription, {}, [text])])]);
}
export {EmptyPanel, SectionHeading, friendly_time, plural, source_kind, status_badge, status_dot, status_label, status_sentence, status_text};
//# sourceMappingURL=Display.js.map
